import React from 'react';
import PropTypes from 'prop-types';
import KeymanListItem from './KeymanListItem';

/**
 * react-window に渡す、仮想リストの1アイテム描画用Adapterコンポーネント。
 *
 * KeymanListItem に index、style、データ等を渡す橋渡しの役割。
 * ・props（data）の構造を flatten せず、親のコンテキストを保ったまま描画できるようにする。
 * ・`PureComponent` により、props が変化したアイテムのみを再描画対象とする。
 *
 * ※ `KeymanListItem` を直接 List に渡すのではなく、このコンポーネントを介することで、
 *    react-window のインターフェース（index, style, data）と噛み合わせている。
 */
class Row extends React.PureComponent {
  render() {
    const { data, index, style } = this.props;
    const { items, count, props } = data;
    const item = items[index];

    return (
      <div style={style}>
        <KeymanListItem
          user={props.user}
          goTo={props.goTo}
          index={index}
          item={item}
          checked={props.isChecked(item, index + count)}
          filterIntentKeywords={props.filterIntentKeywords}
          handleSelectItem={props.handleSelectItem}
          onItemClicked={props.handleSelectItem}
          disabled={props.disabled}
          enableExecutiveListAdvancedSearch={props.enableExecutiveListAdvancedSearch}
          toggleCsvDownloadDialog={props.toggleCsvDownloadDialog}
          toggleExecDetailItemDialog={props.toggleExecDetailItemDialog}
          togglePlanDialog={props.togglePlanDialog}
          togglePromotePlanChangeDialog={props.togglePromotePlanChangeDialog}
          selectedAiTagName={props.selectedAiTagName}
        />
      </div>
    );
  }
}

Row.propTypes = {
  data: PropTypes.shape({
    items: PropTypes.array.isRequired,
    count: PropTypes.number.isRequired,
    props: PropTypes.object.isRequired,
  }).isRequired,
  index: PropTypes.number.isRequired,
  style: PropTypes.object.isRequired,
};

export default Row;



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/Spreadsheet/Row.jsx